import { formatInTimeZone } from "date-fns-tz";

import type { ProfileResponse } from "@/domains/profile/models/types";

export const createProfileDataModel = (profile: ProfileResponse) => {
  return {
    ...profile,
    displayBirthDate: getDisplayBirthDate(profile.birthDate),
    initials: `${profile.firstName[0]}${profile.lastName[0]}`,
  };
};

const getDisplayBirthDate = (birthDate: string) => {
  return formatInTimeZone(birthDate, "UTC", "MMMM d, yyyy");
};
